const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isProbablyUuid(value: unknown): boolean {
  return typeof value === "string" && UUID_RE.test(value.trim());
}

/** Единый URL просмотра сущности training_week. */
export function getTrainingWeekViewPath(weekEntityUuid: string): string {
  const uuid = String(weekEntityUuid || "").trim();
  return isProbablyUuid(uuid) ? `/training-weeks/${uuid}` : "";
}

export function getTrainingWeekViewPathFromWeek(week: {
  id?: string;
  week_entity_uuid?: string;
} | null | undefined): string {
  return getTrainingWeekViewPath(String(week?.week_entity_uuid || week?.id || ""));
}

/** URL «Открыть неделю» (прямой просмотр или redirect через open-week). */
export function getWeekOpenHref(
  week: { id?: string; week_entity_uuid?: string } | null | undefined,
  programUuid: string | null | undefined,
): string {
  const direct = getTrainingWeekViewPathFromWeek(week);
  if (direct) {
    return direct;
  }

  const pid = String(programUuid || "").trim();
  const weekId = String(week?.id || "").trim();
  if (!isProbablyUuid(pid) || weekId === "") {
    return "";
  }

  return `/training-programs/${pid}/open-week/${weekId}`;
}

export async function ensureTrainingWeekEntityUuid(
  api: { apiRequest: (...args: unknown[]) => Promise<unknown> },
  programUuid: string,
  weekId: string,
): Promise<string> {
  const response = (await api.apiRequest(
    "training_program_builder/ensure_week_entity",
    { uuid: programUuid, week_id: weekId },
    true,
    null,
    null,
    null,
    { setPageData: false, sideEffects: false },
  )) as { data?: { week_entity_uuid?: string }; status?: boolean; error?: string };

  if (response?.status === false) {
    throw new Error(response?.error || "Не удалось подготовить неделю.");
  }

  const uuid = String(response?.data?.week_entity_uuid || "").trim();
  if (!isProbablyUuid(uuid)) {
    throw new Error("Сервер не вернул uuid недели.");
  }

  return uuid;
}
